import { useTranslator } from "@eo-locale/react";

import { Text } from "@/storybook-components";

const RequiredField = (): JSX.Element => {
  const { translate } = useTranslator();

  return (
    <Text
      my={4}
      fontSize="0.75rem"
      lineHeight="133%"
      fontWeight="normal"
      letterSpacing="0.2px"
      color="gray.600"
    >
      {translate("questions.requiredField")}
    </Text>
  );
};

export default RequiredField;
